import { BASE_ENDPOINT } from "../../../endpoint";

export const addCurrencyService = async (payload: any, token: string) => {
    try {
        const response = await fetch(`${BASE_ENDPOINT}/configuration/currency`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(payload)
        });
        const res = await response.json();
        if (!response.ok) {
            console.error('Error:', res);
            throw new Error(res.message);
        }
        return res;
    } catch (error) {
        console.error('API fetch error:', error);
        throw error;
    }
};
